import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { ITranslateValueModel } from '../models/translate-value.model';

const routes = {
  getTranslatedText: () => `/v1/language/translate`
};

@Injectable({
  providedIn: 'root'
})
export class TranslateTextService {

  constructor(private http: HttpClient) { }

  getTranslatedText(text: string): Observable<any> {
    const payload: ITranslateValueModel = {
      text: text
    };
    return this.http.post<ITranslateValueModel>(routes.getTranslatedText(), payload).pipe(map(res => { return res.text }));
  }
}
